module.exports = __webpack_public_path__ + "static/media/pink-heart-checked.0df9a297.svg";